var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _g4, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 202,
    viewBox: "0 0 189 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_760",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 0,
    width: 84,
    height: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2961 0H122.745V91.2242H39.2961V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.857 91.0518C115.232 91.0518 113.102 88.9217 113.102 86.2967V41.4745C113.102 23.8323 98.7492 9.4791 81.1173 9.4791C63.4751 9.4791 49.1219 23.8323 49.1219 41.4745V86.2967C49.1219 88.9217 46.9936 91.0518 44.3772 91.0518C41.7435 91.0518 39.6238 88.9217 39.6238 86.2967V41.4745C39.6238 18.5926 58.2354 -0.0206909 81.1173 -0.0206909C103.999 -0.0206909 122.612 18.5926 122.612 41.4745V86.2967C122.612 88.9217 120.493 91.0518 117.857 91.0518Z",
    fill: "#100F0F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_61_760",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 56,
    width: 170,
    height: 146
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56.3434H169.106V202H0V56.3434Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_61_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.07 190.355C169.07 196.705 163.87 201.895 157.519 201.895H11.7695C5.41907 201.895 0.22937 196.705 0.22937 190.355L0.357 67.9422C0.357 61.5917 5.55877 56.3917 11.9075 56.3917H154.765C161.115 56.3917 166.315 61.5917 166.315 67.9422L169.07 190.355Z",
    fill: "#F58013"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_61_760",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 56,
    width: 171,
    height: 146
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9858 56.3434H188.092V202H18.9858V56.3434Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_61_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.959 190.355C187.959 196.705 182.769 201.895 176.419 201.895H30.6691C24.3186 201.895 19.1186 196.705 19.1186 190.355L19.2566 67.9422C19.2566 61.5917 24.448 56.3917 30.7967 56.3917H173.666C180.015 56.3917 185.215 61.5917 185.215 67.9422L187.959 190.355Z",
    fill: "#F9AF23"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8586 86.2966C75.8586 92.3883 70.9156 97.3314 64.8238 97.3314C58.7218 97.3314 53.7787 92.3883 53.7787 86.2966C53.7787 80.1945 58.7218 75.2618 64.8238 75.2618C70.9156 75.2618 75.8586 80.1945 75.8586 86.2966Z",
    fill: "#F58013"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.684 86.2966C150.684 92.3883 145.741 97.3314 139.649 97.3314C133.547 97.3314 128.604 92.3883 128.604 86.2966C128.604 80.1945 133.547 75.2618 139.649 75.2618C145.741 75.2618 150.684 80.1945 150.684 86.2966Z",
    fill: "#F58013"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_61_760",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 84,
    height: 92
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4896 0H143.939V91.2242H60.4896V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_61_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.977 91.0518C136.352 91.0518 134.222 88.9217 134.222 86.2967V41.4745C134.222 23.8323 119.868 9.4791 102.237 9.4791C84.5943 9.4791 70.2411 23.8323 70.2411 41.4745V86.2967C70.2411 88.9217 68.1111 91.0518 65.4861 91.0518C62.861 91.0518 60.7327 88.9217 60.7327 86.2967V41.4745C60.7327 18.5926 79.3442 -0.0206909 102.237 -0.0206909C125.118 -0.0206909 143.73 18.5926 143.73 41.4745V86.2967C143.73 88.9217 141.602 91.0518 138.977 91.0518Z",
    fill: "#141515"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.426 123.622L146.603 123.532C143.573 123.394 141.017 125.482 140.888 128.218L140.165 143.62L140.155 143.601L138.144 140.034L119.977 107.861C118.709 105.612 115.857 104.82 113.608 106.088L112.25 106.85C110.003 108.128 109.21 110.972 110.477 113.22L119.175 128.634C118.085 128.396 116.916 128.534 115.876 129.118L114.51 129.881C112.271 131.159 111.469 134.003 112.747 136.25C111.469 134.003 108.625 133.209 106.378 134.477L105.01 135.25C102.771 136.517 101.969 139.372 103.237 141.619C101.969 139.372 99.1269 138.578 96.8675 139.846L95.5205 140.608C93.2715 141.878 92.4695 144.73 93.7371 146.978L101.493 160.717C101.493 160.717 111.736 179.449 116.034 184.62C120.017 189.444 120.879 188.235 122.631 189.979C125.217 192.554 127.694 194.703 129.943 193.435L151.319 181.371C153.577 180.103 153.489 176.705 152.15 173.318C151.666 172.09 151.012 168.642 151.338 168.078C151.338 168.078 151.973 165.789 151.943 165.382L153.666 128.822C153.796 126.088 151.446 123.759 148.426 123.622Z",
    fill: "#F9AF23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.4d2f7a6d524442b441cc803dcdd4a88b.svg";
export { ForwardRef as ReactComponent };